export const WEEKDAYS = [
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 7 },
];

export function to12h(time) {
  const [h, m] = time.split(':').map(Number);
  const suffix = h >= 12 ? 'pm' : 'am';
  let hour = h % 12;
  if (hour === 0) hour = 12;
  return m === 0 ? `${hour}${suffix}` : `${hour}:${m < 10 ? '0' + m : m}${suffix}`;
}

export function getStoreLocalTimeParts(timeZone, referenceDate = new Date()) {
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  });

  const parts = fmt.formatToParts(referenceDate);

  const getPart = type => {
    const p = parts.find(x => x.type === type);
    return p ? parseInt(p.value, 10) : NaN;
  };

  const year = getPart('year');
  const month = getPart('month');
  const day = getPart('day');
  const hour = getPart('hour');
  const minute = getPart('minute');
  const wdName = parts.find(x => x.type === 'weekday')?.value;

  const weekdayLookup = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };

  const weekday = weekdayLookup[wdName] ?? 1;
  const minutesSinceMidnight = hour * 60 + minute;

  return { year, month, day, weekday, minutesSinceMidnight };
}

export function windowsForWeekday(dailyArray, weekdayValue) {
  return Array.isArray(dailyArray)
    ? dailyArray.filter(({ day, opensAt, closesAt }) => day === weekdayValue && opensAt !== closesAt)
    : [];
}

export function formatBusinessHoursRows(businessHours) {
  if (!businessHours || !Array.isArray(businessHours.daily)) {
    return [];
  }

  const { timeZone, daily } = businessHours;
  const { year, month, day, weekday } = getStoreLocalTimeParts(timeZone);

  const isoDateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T12:00:00`;
  const localNoon = new Date(isoDateString);

  return WEEKDAYS.map(({ label, value }) => {
    const delta = value - weekday;
    const candidate = new Date(localNoon);
    candidate.setDate(localNoon.getDate() + delta);

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      month: 'long',
      day: 'numeric',
    });
    const formattedDate = dateFormatter.format(candidate);

    const windows = windowsForWeekday(daily, value);
    const timeText =
      windows.length > 0
        ? windows.map(w => `${to12h(w.opensAt)}–${to12h(w.closesAt)}`).join(', ')
        : 'Closed';

    return {
      weekdayValue: value,
      dayLabel: label,
      dateLabel: formattedDate,
      timeText,
      isToday: delta === 0,
    };
  });
}
